import * as React from 'react';
import Header from '../Components/Header';
import MiniHeader from '../Components/MiniHeader';


function MainWrapper() {
  return (
    <div>
       
      
    </div>
  )
}

export default MainWrapper
